/**
 * @author wuTao
 * @description NEV认证详情页面配置
 * @Date 2022/04/29
 */
import React from 'react'
import {component_tool, utils_tool} from '@/tool';
import {WizTableForm} from '@/containers/common';
import moment from "moment";

let {$$, checkStrLength} = utils_tool;
const organization = WizTableForm.Config.organizationByNoFilter(this, {apiParams: {state: 1}});
const position = WizTableForm.Config.positionByNoFilter(this, {apiParams: {state: 1}});
const classInfoConfig = WizTableForm.Config.classInfo(this, {apiParams: {state: 1,isPower:false}});
const remoteAuthConfig = WizTableForm.Config.remoteAuth(this, {apiParams: {type: 2,isPower:false}});
const formatterDate = (val) => {
  return val ? moment(val).format('YYYY.MM.DD') : '';
}
const formatterTime = (val) => {
  return val ? moment(val).format('HH:mm:ss') : '';
}
let {WizModal, WizTimePicker} = component_tool;
const {RangePicker} = WizTimePicker;
let ref_;


//配置项
let componentName = 'nevRemoteAuthDetail'
const _columns = ({searchRemoteAuthName = ''}) => {
  return [
    {
      name: "id",
      fromItem: {
        type: "hidden"
      }
    }, {
      title: "检核项目",
      name: "remoteAuthIdList",
      searchItem: {
        ...remoteAuthConfig,
        diy: WizTableForm,
      },
    },
    {
      title: "认证场次",
      name: "searchName",
      searchItem: {},
    },
    {
      title: "姓名",
      name: "searchFullName",
      searchItem: {},
    },
    {
      title: "账号",
      name: "searchUserName",
      searchItem: {},
    },
    {
      title: "组织名称",
      name: "orgIdList",
      searchItem: {
        ...organization,
        diy: WizTableForm,
      },
    },
    {
      title: "岗位",
      name: "positionIdList",
      searchItem: {
        ...position,
        diy: WizTableForm
      },
    },
    {
      title: "班级",
      name: "classIdList",
      searchItem: {
        ...classInfoConfig,
        diy: WizTableForm
      },
    },
    {
      title: '认证日期',
      name: 'openTime',
      searchItem: {
        type: 'date~',
        showTime: false,
        format: 'YYYY-MM-DD'
      }
    },
    {
      title: "姓名",
      name: "fullName",
      tableItem: {},
    },
    {
      title: "账号",
      name: "userName",
      tableItem: {},
    },
    {
      title: "手机号",
      name: "mobile",
      tableItem: {},
    },
    {
      title: "组织名称",
      name: "orgName",
      tableItem: {},
    },
    {
      title: "组织编码",
      name: "orgCode",
      tableItem: {},
    },
    {
      title: "岗位",
      name: "positionName",
      tableItem: {},
    },
    {
      title: "认证场次",
      name: "name",
      tableItem: {},
    },

    {
      title: "认证日期",
      name: "authDate",
      tableItem: {
        width: 120,
        render: (text, record) => {
          return formatterDate(text)
        }
      },
    },
    {
      title: "认证时间",
      tableItem: {
        width: 200,
        render: (text, record) => {
          const {startDate, endDate} = record;
          let authTimeStr = '';
          if (startDate != null && startDate != '' && endDate != null && endDate != '') {
            authTimeStr = formatterTime(startDate) + ' ~ ' + formatterTime(endDate);
          }
          return authTimeStr
        }
      },
    },
    {
      title: "状态",
      name: "scoreState",
      searchItem: {
        type: 'select'
      },
      dict: [
        {code: 1, codeName: '待评分'},
        {code: 2, codeName: '已评分'},
        {code: 3, codeName: '未评分'},
      ],
    },
    {
      title: "状态",
      name: "scoreStateStr",
      tableItem: {},
    },
    {
      title: "总得分",
      name: "score",
      tableItem: {
        render: (text, record) => {
          return text === null && text < 0 ? '' : text
        }
      },
    },
    {
      title: "通过状态",
      name: "pass",
      dict: [
        {code: 0, codeName: '未通过'},
        {code: 1, codeName: '通过'},
      ],
      searchItem: {
        type: 'select'
      },
    },
    {
      title: "通过状态",
      name: "passStr",
      tableItem: {},
    }
  ];
}


const templateConfig = (data) => {
  const {self, name} = data
  return {
    mainProps: {},
    content: {
      name: "WizTableList",
      params: {
        columns: _columns({searchRemoteAuthName: name}),
        searchBarProps: {
          dataFormat: (v) => {
            let value = Object.assign([], v)
            if (value['openTime'] && value['openTime'].length === 2) {
              value['authStartDate'] = moment(value['openTime'][0]).format("YYYY-MM-DD") + " 00:00:01";
              value['authEndDate'] = moment(value['openTime'][1]).format("YYYY-MM-DD") + " 23:59:59";
            }
            return value
          },
          buttonSort: ['export'],
          buttons: [
            {
              key: 'export',
              custom: true,
              params: {icon: 'export', children: '导出'},
              customOnClick: {
                key: 'action',
                params: {
                  apiKey: 'export',
                  apiParams: {}
                },
                formatParams: (rows, record, filters, callback) => {
                  return {...filters}
                }
              }
            }
          ]
        },
        modalFormProps: {},
        dataTableProps: {
          rowKey: "id",
          selectType: "checkbox",
          isScroll: true,
          bordered: false,
          paging: false,
          loading: false
        },
        rowOperateSort: ['modifyScore','abilityRemote'],
        rowOperateView: [
          {
            key: "modifyScore",
            custom: true,
            params: {children: "去评分"},
            customOnClick: {
              key: 'jumpPage',
              params: {
                key: 'push',
                pathname: '/remoteAuth/lectureNevAuthDetail/score',
                record: {jumpPageType: 'lectureNevDetail'}
              }
            },
            recordChangeParams: ({record, rows}) => {
              const {scoreState} = record;
              let disabled = 0;
              let hidden = 0;
              if (scoreState != null && scoreState === 2) {
                disabled = 1;
                hidden = 1;
              }
              return {disabled: disabled, hidden: hidden}
            },
          },
          {
            key: "abilityRemote",
            custom: true,
            params: {children: "能力认证模型"},
            customOnClick: {
              key: 'jumpPage',
              params: {
                key: 'push',
                pathname: '/remoteAuth/nevRemoteAuthDetailList/score',
              }
            },
            recordChangeParams: ({record, rows}) => {
              const {scoreState} = record;
              let disabled = 0;
              let hidden = 0;
              if (scoreState != null && scoreState !== 2) {
                disabled = 1;
                hidden = 1;
              }
              return {disabled: disabled, hidden: hidden}
            },
          },
        ]
      }
    }
  }
};

const _apis = (data) => {
  const {currentLoginUserPersonId} = data;
  return {
    list: {
      path: `${componentName}/listByPage`,
      payload: {
        key: `${componentName}@listByPage`,
        apiParams: {lectureId: currentLoginUserPersonId ? currentLoginUserPersonId : 'xxxxxxxxxxxxxxxxxx', type: 2}
      }
    },
    export: {
      path: `${componentName}/export`,
      payload: {
        key: `${componentName}@export`,
        apiParams: {lectureId: currentLoginUserPersonId ? currentLoginUserPersonId : 'xxxxxxxxxxxxxxxxxx', type: 2}
      }
    },
  }
}
let reduxTemplateCofig = (args) => {
  let {currentLoginUserPersonId} = args;
  return {
    apis: _apis({currentLoginUserPersonId}),
    componentName,
    initApiKeys: ['list'],
    keepInitApiParams: true,
    needLoading: true,
    ...args
  }
};

export {reduxTemplateCofig, templateConfig};
